import styles from './Placeholder.module.css';

interface PlaceholderProps {
  phase: string;
  what: string;
  detail: string;
}

/**
 * Honest stand-in for a screen that lands in a later phase, so the shell can be
 * reviewed end-to-end without anything pretending to be finished.
 */
export function Placeholder({ phase, what, detail }: PlaceholderProps) {
  return (
    <div className={styles.box}>
      <span className={styles.phase}>{phase}</span>
      <p className={styles.what}>{what}</p>
      <p>{detail}</p>
    </div>
  );
}
